"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var styles = {
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '16px',
  color: '#919499',
  textAlign: 'center',
  paddingBottom: '24px'
};
var SurchargeAnnotation = function SurchargeAnnotation(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles,
    className: "SurchargeAnnotation"
  }, children);
};
var _default = exports["default"] = SurchargeAnnotation;